import React from 'react';
import PropTypes from 'prop-types';
import { Card, SecondaryAction } from '~/pistonSalsita';
import {
  Col,
  Container,
  OpacityOverlay,
  Placeholder,
  Row,
} from '@administrate/piston-ux';

export const PaymentMethodSkeleton = ({ t }) => (
  <OpacityOverlay on>
    <Card>
      <h1 className="CardTitle">{t('weblink:paymentMethod')}</h1>
      <Card.Body>
        <Container fluid>
          <Row className="mb-3">
            <Col xs={12}>
              <Placeholder />
            </Col>
          </Row>
          <Row className="mb-3">
            <Col xs={12} md={6}>
              <Placeholder />
            </Col>
            <Col xs={12} md={6}>
              <Placeholder />
            </Col>
          </Row>
        </Container>
      </Card.Body>
      <Card.Footer
        right={<SecondaryAction label={t('weblink:continue')} disabled />}
      />
    </Card>
  </OpacityOverlay>
);

PaymentMethodSkeleton.propTypes = {
  t: PropTypes.func.isRequired,
};
